class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search-results');
    this.input.addEventListener(
      'input',
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this),
    );
  }

  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=article&resources[limit]=5&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.styleResults();
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  styleResults() {
    // Add custom styling to the search results
    const resultsList = this.predictiveSearchResults.querySelector('.predictive-search__results-list');
    if (resultsList) {
      resultsList.classList.add('tw-space-y-2');
    }

    const resultItems = this.predictiveSearchResults.querySelectorAll('.predictive-search__list-item');
    resultItems.forEach((item) => {
      item.classList.add('tw-p-2', 'tw-hover:bg-gray-100');

      const link = item.querySelector('a');
      if (link) {
        link.classList.add('tw-flex', 'tw-items-center');
      }

      const content = item.querySelector('.predictive-search__item-content');
      if (content) {
        content.classList.add('tw-flex', 'tw-flex-col');
      }

      const heading = item.querySelector('.predictive-search__item-heading');
      if (heading) {
        heading.classList.add('tw-font-semibold');
      }
    });

    const searchForButton = this.predictiveSearchResults.querySelector('.predictive-search__search-for-button');
    if (searchForButton) {
      searchForButton.classList.add('tw-mt-4');
    }
  }

  open() {
    this.predictiveSearchResults.classList.remove('tw-hidden');
    this.predictiveSearchResults.classList.add(
      'tw-absolute',
      'tw-left-0',
      'tw-right-0',
      'tw-mt-2',
      'tw-bg-white',
      'tw-border',
      'tw-border-gray-300',
      'tw-rounded-md',
      'tw-shadow-lg',
      'tw-z-10',
    );
  }

  close() {
    this.predictiveSearchResults.classList.add('tw-hidden');
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
